import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import config from "../../../../../../config";

const CMC20_HISTORY_COUNT = 10; // historical endpoint зараз повертає максимум 10 daily points

const formatCMC20Value = (value) => {
  const number = Number(value);

  if (!Number.isFinite(number)) {
    return "--";
  }

  return number.toFixed(2);
};

const formatCMC20Change = (value) => {
  const number = Number(value);

  if (!Number.isFinite(number)) {
    return "--";
  }

  return `${number >= 0 ? "+" : ""}${number.toFixed(2)}%`;
};

const normalizeHistoricalData = (data) => {
  if (Array.isArray(data)) {
    return data;
  }

  if (data && typeof data === "object") {
    return Object.values(data);
  }

  return [];
};

export const useCMC20History = () => {
  const [cmc20Latest, setCMC20Latest] = useState(null);
  const [cmc20HistoricalData, setCMC20HistoricalData] = useState([]);
  const [isCMC20Loading, setIsCMC20Loading] = useState(true);

  useEffect(() => {
    const fetchCMC20Data = async () => {
      try {
        setIsCMC20Loading(true);

        const [latestResponse, historicalResponse] = await Promise.all([
          axios.get(`${config.api_url}/coinmarketcap/cmc20/latest`),

          axios.get(`${config.api_url}/coinmarketcap/cmc20/historical`, {
            params: {
              count: CMC20_HISTORY_COUNT,
              interval: "daily",
            },
          }),
        ]);

        setCMC20Latest(latestResponse.data?.data || null);

        setCMC20HistoricalData(
          normalizeHistoricalData(historicalResponse.data?.data),
        );
      } catch (error) {
        console.error("Failed to fetch CMC20 data", error);

        setCMC20Latest(null);
        setCMC20HistoricalData([]);
      } finally {
        setIsCMC20Loading(false);
      }
    };

    fetchCMC20Data();
  }, []);

  const cmc20Data = useMemo(() => {
    const historicalItems = normalizeHistoricalData(cmc20HistoricalData);

    const cmc20ChartData = historicalItems
      .map((item) => Number(item.value || 0))
      .filter((value) => Number.isFinite(value) && value > 0);

    const cmc20Value = Number(cmc20Latest?.value || 0);

    const cmc20Change =
      cmc20Latest?.value_24h_percentage_change ?? null;

    return {
      cmc20ChartData,
      cmc20Value,
      formattedCMC20Value: formatCMC20Value(cmc20Value),
      cmc20Change,
      formattedCMC20Change: formatCMC20Change(cmc20Change),
      isCMC20Positive:
        cmc20Change !== null ? Number(cmc20Change) >= 0 : undefined,
    };
  }, [cmc20Latest, cmc20HistoricalData]);

  return {
    ...cmc20Data,
    isCMC20Loading,
  };
};